import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import Media from "components/Media";
import Founders from "../../../../../public/founders.png";

import styles from "./styles.module.scss";
import { investors } from "./constants";

const OurInvestors: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <img src={Founders.src} alt="" className={styles.founders} />
      <Media at={["desktop"]}>
        <Label variant="h3-centered" color="primary">
          Backed By
        </Label>
      </Media>
      <Media at={["responsive"]}>
        <Label variant="h1-centered" color="primary">
          Backed By
        </Label>
      </Media>
      <div className={styles.investors}>
        {investors.map((Icon) => (
          <Icon className={styles.icon} />
        ))}
      </div>
    </Content>
  );
};

export default OurInvestors;
